import { Box, SxProps, type Theme } from '@mui/material';
import { PropsWithChildren } from 'react';

type TagProps = {
  readonly style: 'brandLight' | 'brand' | 'outline' | 'neutral' | 'disabled';
  readonly size: 'default' | 'small';
};

const getStylesForVariant = (style: TagProps['style']): SxProps<Theme> => {
  switch (style) {
    case 'brandLight':
      return {
        backgroundColor: 'surface.brandLight',
        color: 'text.brand',
      };
    case 'brand':
      return {
        backgroundColor: 'surface.brand',
        color: 'text.primaryOnBrand',
      };
    case 'outline':
      return {
        backgroundColor: 'surface.background',
        border: '1px solid',
        borderColor: 'border.default',
      };
    case 'neutral':
      return {
        backgroundColor: 'surface.elevated',
        color: 'text.primary',
      };
    case 'disabled':
      return {
        backgroundColor: 'surface.disabledSolid',
        color: 'text.disabledSolid',
      };
  }
};

export const Tag = ({ style, size, children }: PropsWithChildren<TagProps>) => (
  <Box
    sx={getStylesForVariant(style)}
    display="inline-flex"
    width="fit-content"
    p="4px"
    pr="8px"
    borderRadius="4px"
    alignItems="center"
    gap={0.5}
    fontSize={size == 'default' ? '0.875rem' : '0.75rem'}
    lineHeight="0.875rem"
  >
    {children}
  </Box>
);
